namespace GeniuzPOS.Purchase {
    export interface ListAppPurInvoiceRow {
        SendForAppfg?: sendapp;
        WaitLv?: number;
        WaitApprove?: string;
        SysDocNo?: string;
        ItemTypeFg?: POTypeFg;
        SupplierId?: string;
        NetTotalInVat?: number;
        PurIvNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        LastApprove?: string;
        ApproveDate?: string;
        ShipId?: string;
        Remark?: string;
    }

    export namespace ListAppPurInvoiceRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'WaitApprove';
        export const localTextPrefix = 'Purchase.ListAppPurInvoice';
        export const lookupKey = 'Purchase.ListAppPurInvoice';

        export function getLookup(): Q.Lookup<ListAppPurInvoiceRow> {
            return Q.getLookup<ListAppPurInvoiceRow>('Purchase.ListAppPurInvoice');
        }
        export const deletePermission = '5Purchase:ใบรับสินค้า(แจ้งหนี้ซื้อ)(PI):อนุมัติ:Modify';
        export const insertPermission = '5Purchase:ใบรับสินค้า(แจ้งหนี้ซื้อ)(PI):อนุมัติ:Modify';
        export const readPermission = '5Purchase:ใบรับสินค้า(แจ้งหนี้ซื้อ)(PI):อนุมัติ:View';
        export const updatePermission = '5Purchase:ใบรับสินค้า(แจ้งหนี้ซื้อ)(PI):อนุมัติ:Modify';

        export declare const enum Fields {
            SendForAppfg = "SendForAppfg",
            WaitLv = "WaitLv",
            WaitApprove = "WaitApprove",
            SysDocNo = "SysDocNo",
            ItemTypeFg = "ItemTypeFg",
            SupplierId = "SupplierId",
            NetTotalInVat = "NetTotalInVat",
            PurIvNo = "PurIvNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            LastApprove = "LastApprove",
            ApproveDate = "ApproveDate",
            ShipId = "ShipId",
            Remark = "Remark"
        }
    }
}
